<template>
  <v-container fluid class="pa-0">
    <v-card class="mb-4">
      <v-toolbar card color="primary" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>{{$t('inGame.companies.companies')}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          :label="$t('general.search')"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
        <v-spacer></v-spacer>
      </v-card-title>
      <data-table
        :selectAll="false"
        :action="false"
        :items="companies"
        :headers="headers"
        :search="search"
        :hideActions="true"
      ></data-table>
    </v-card>
  </v-container>
</template>
<script>
import DataTable from "@/components/DataTable";
export default {
  name: "InGameCompanies",
  components: {
    DataTable
  },
  data() {
    return {
      search: "",
      steps: [
        this.$t('inGame.companies.steps.clientOrder'),
        this.$t('inGame.companies.steps.clientOrder'),
        this.$t('inGame.companies.steps.clientShipment'),
        this.$t('inGame.companies.steps.supplierShimpentWaiting'),
        this.$t('inGame.companies.steps.supplierShipments'),
        this.$t('inGame.companies.steps.board'),
        this.$t('inGame.companies.steps.supplierOrders'),
        this.$t('inGame.companies.steps.board')
      ],
      headers: [
        {
          text: this.$t('companiesSettings.level'),
          align: 'center',
          value: 'level'
        },
        {
          text: this.$t('companiesSettings.logo'),
          align: 'center',
          value: 'logo',
          sortable: false,
          img: true
        },
        {
          text: this.$t('companiesSettings.name'),
          align: 'center',
          value: 'name'
        },
        {
          text: this.$t('inGame.companies.playerName'),
          align: 'center',
          value: 'playerName'
        },
        {
          text: this.$t('inGame.companies.assigned'),
          align: 'center',
          value: 'assigned',
          logo: true
        },
        {
          text: this.$t('inGame.companies.ready'),
          align: 'center',
          value: 'ready',
          logo: true
        },
        {
          text: this.$t('general.week'),
          align: 'center',
          value: 'week'
        },
        {
          text: this.$t('inGame.companies.step'),
          align: 'center',
          value: 'step'
        }
      ]
    };
  },
  mounted() {
  },
  methods: { },
  computed: {
    companies () {
      return this.$store.state.games.current ? this.$store.state.games.current.companies.filter((company) => company.assignable).map((company) => { 
        return {
          level: company.level,
          instance: company.instance,
          name: company.name,
          playerName: company.playerName,
          assigned: company.assigned ? 'check_circle' : 'close',
          ready: company.ready ? 'check_circle' : 'close',
          week: company.week,
          step: company.step + ' - ' + this.steps[company.step],
          logo: company.companieSettings.logo
        }
      }) : [] 
    }
  }
};
</script>
